module.exports = __webpack_public_path__ + "static/media/Brios-Coconut-Descripcion-Mobile.8e998061.webp";